var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cleave',{staticClass:"form-control",class:{'is-invalid':  _vm.invalid},attrs:{"raw":false,"options":_vm.options},model:{value:(_vm.p_value),callback:function ($$v) {_vm.p_value=_vm._n($$v)},expression:"p_value"}})}
var staticRenderFns = []

export { render, staticRenderFns }